import {getAbsoluteUrl} from "modules/utils/urlUtill";
import {globalFetch} from "initializers/ActiveBrandInitializer";
import {UserSettings} from "modules/user_settings/model/UserSettings";


class UserSettingsInitializer {

    fetchSettings = (): Promise<UserSettings> =>
        globalFetch(getAbsoluteUrl('api/user-settings'), 'GET')
            .then((resp: UserSettings) => {
                return resp;
            })

    fetchSmsSettings = (): Promise<UserSettings> =>
        globalFetch(getAbsoluteUrl('api/sms-settings'), 'GET')
            .then((resp: UserSettings) => {
                return resp;
            })
}

export const USER_SETTINGS_INITIALIZER = new UserSettingsInitializer();
